import React, { useRef} from "react";
import ToggleBar from "../../commoncomponents/toggleBar";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

const getSensorStats = (logs, field) => {
  const values = (logs || [])
    .map((log) => log[field])
    .filter((value) => value !== null && value !== undefined && value !== "")
    .map((value) => Number(value))
    .filter((value) => Number.isFinite(value));

  if (values.length === 0) {
    return null;
  }

  const total = values.reduce((sum, value) => sum + value, 0);
  return {
    min: Math.min(...values),
    max: Math.max(...values),
    average: total / values.length,
  };
};

const formatTemperature = (value) => `${Number(value).toFixed(1)}\xB0C`;

const TemperatureStatsTile = ({ label, colour, stats }) => (
  <div className={`temperatureStatsTile ${colour}`}>
    <span className="temperatureStatsTitle">{label}</span>
    <div className="temperatureStatsValues">
      <span>
        <strong>Min</strong>{" "}
        {stats ? formatTemperature(stats.min) : "N/A"}
      </span>
      <span>
        <strong>Max</strong>{" "}
        {stats ? formatTemperature(stats.max) : "N/A"}
      </span>
      <span>
        <strong>Avg</strong>{" "}
        {stats ? formatTemperature(stats.average) : "N/A"}
      </span>
    </div>
  </div>
);

function RealTimeTemperature(props) {
  let tempAEnabled = props.tempAEnabled;
  let tempBEnabled = props.tempBEnabled;
  const statsTileCount = [tempAEnabled, tempBEnabled].filter(Boolean).length;
  const tempAStats = getSensorStats(props.temperatureLogs, "tempA");
  const tempBStats = getSensorStats(props.temperatureLogs, "tempB");

  const dictinarySelection = (value) => {
    return props.utcObj[value];
  };

  const options = {
    title: {
      text: "",
    },

    xAxis: {
      type: "datetime",
      tickInterval:   3600 * 1000,
    },

    tooltip: {
      formatter: function () {
        return this.points.reduce(function (s, point) {
          return (
            s +
            "<br/>" +
            point.series.name +
            ": " +
            "<b>" +
            point.y +
            `\xB0C` +
            "</b>"
          );
        }, "<b>" + dictinarySelection(this.x) + "</b>");
      },
      shared: true,
    },
      //legend: {
      //    enabled: tempBEnabled
      //},
    series: [
      {

        type: "line",
        data: props.totalGraph,
        name: "Temp A",
        color: "#dc3545",
        zIndex: 2,
        visible: tempAEnabled,
        showInLegend: tempAEnabled,
        pointStart:props.totalGraph.length>0? props.totalGraph[0][0]:"",
      },
      {
        type: "line",
        data: props.totalGraphSecond,
        name: "Temp B",
        color: "#337ab7",
        zIndex: 1,
        visible: tempBEnabled,
        showInLegend: tempBEnabled
        },

    ],

    };
    const chart = useRef();
    const data = <HighchartsReact ref={chart} highcharts={Highcharts} options={options} />;
    const headerContent = statsTileCount > 0 ? (
      <div className={`temperatureStatsGrid ${statsTileCount === 1 ? "single" : "double"}`}>
        {tempAEnabled && <TemperatureStatsTile label="Temp A" colour="tempA" stats={tempAStats} />}
        {tempBEnabled && <TemperatureStatsTile label="Temp B" colour="tempB" stats={tempBStats} />}
      </div>
    ) : null;

    const handleChartDownLoad = () => {
        if (chart && chart.current && chart.current.chart) {
            chart.current.chart.exportChart();
        }
     };
  return (
    <ToggleBar
      caption="Temperature"
      download={handleChartDownLoad}
      icon="fa-building"
      color="#337ab7"
      headerContent={headerContent}
      content={data}
    />
  );
}

export default RealTimeTemperature;
